import $ from 'jquery';

// config jquery variables for other lib use jQuery (such as bootstrap)
window.$ = $;
window.jQuery = $;
global.jQuery = $;
// const bootstrap = require('bootstrap');
// console.log(bootstrap)